import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import Vector from "../imagem/Vector.svg";
import InputGeral from "../Componets/InputGeral";
import LabelGeral from "../Componets/LabelGeral";
import { formatarTelefone } from "../utils/formatarInputTelefone";
import { limparMascara } from "../utils/formataInputTelefoneVazio";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 330,
  bgcolor: "background.paper",
  border: "none",
  boxShadow: 24,
  height: 450,
  p: 4,
  borderRadius: 3,
};

function CadastrarAluno({
  open,
  cancelar,
  editando,
  alunoEditado,
  cadastrar,
  editar,
  loadModal,
}) {
  const alunoVazio = {
    idAluno: null,
    nome: "",
    turma: "",
    telefone: "",
    email: "",
  };

  const [aluno, setAluno] = useState(alunoVazio);

  useEffect(() => {
    if (open) {
      if (editando && !!(alunoEditado?.id || alunoEditado?.idAluno)) {
        setAluno({
          idAluno: !!alunoEditado.id ? alunoEditado.id : alunoEditado.idAluno,
          nome: alunoEditado.nome,
          turma: alunoEditado.turma,
          telefone: formatarTelefone(alunoEditado.telefone),
          email: alunoEditado.email,
        });
      }
    } else {
      setAluno(alunoVazio);
    }
  }, [open]);

  return (
    <div>
      <Modal
        open={open}
        onClose={cancelar}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "end",
                margin: -15,
              }}
            >
              <Button
                onClick={cancelar}
                style={{ display: "flex", justifyContent: "flex-end" }}
              >
                <img src={Vector} alt="" />
              </Button>
            </div>
            <Typography variant="h6" component="h6">
              {editando
                ? "Editar informações do aluno"
                : "Cadastrar novo aluno"}
            </Typography>
          </div>

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: 20,
              marginTop: 20,
            }}
          >
            <div>
              <LabelGeral
                nome="Nome"
                style={{
                  justifyContent: "center",
                  display: "flex",
                  alignItems: "center",
                  left: 10,
                  fontFamily: "Roboto",
                }}
              />
              <InputGeral
                placeholder={"Digite um nome"}
                value={aluno?.nome}
                onChange={(event) =>
                  setAluno((prev) => {
                    return { ...prev, nome: event.target.value };
                  })
                }
              />
            </div>
            <div>
              <LabelGeral
                nome="Turma"
                style={{
                  justifyContent: "center",
                  display: "flex",
                  alignItems: "center",
                  left: 10,
                  fontFamily: "Roboto",
                }}
              />
              <InputGeral
                placeholder={"Digite uma turma"}
                value={aluno?.turma}
                onChange={(event) => {
                  setAluno((prev) => ({
                    ...prev,
                    turma: event.target.value,
                  }));
                }}
              />
            </div>
            <div>
              <LabelGeral
                nome="Telefone"
                style={{
                  justifyContent: "center",
                  display: "flex",
                  alignItems: "center",
                  left: 10,
                  fontFamily: "Roboto",
                }}
              />
              <InputGeral
                placeholder={"Digite um telefone"}
                value={formatarTelefone(aluno?.telefone || "")}
                onChange={(event) => {
                  const telefoneSemMascara = limparMascara(event.target.value);
                  setAluno((prev) => ({
                    ...prev,
                    telefone: limparMascara(telefoneSemMascara),
                  }));
                }}
              />
            </div>
            <div>
              <LabelGeral
                nome="Email"
                style={{
                  justifyContent: "center",
                  display: "flex",
                  alignItems: "center",
                  left: 10,
                  fontFamily: "Roboto",
                }}
              />
              <InputGeral
                placeholder={"Digite um email"}
                value={aluno?.email}
                type="Email"
                onChange={(event) =>
                  setAluno((prev) => {
                    return { ...prev, email: event.target.value };
                  })
                }
              />
            </div>
          </div>

          <div
            className="buttons"
            style={{
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Button
              onClick={cancelar}
              variant="contained"
              style={{
                color: "var(--cor-roxoEscuro)",
                backgroundColor: "var(--cor-roxoInput)",
                border: "2px solid var(--cor-roxoEscuro)",
                borderRadius: "0.5em",
                fontSize: 18,
                width: 160,
                top: 30,
              }}
            >
              Cancelar
            </Button>
            <Button
              onClick={() => (editando ? editar(aluno) : cadastrar(aluno))}
              variant="contained"
              disabled={loadModal}
              style={{
                color: "var(--cor-branco)",
                backgroundColor: "var(--cor-roxoEscuro)",
                border: "2px solid var(--cor-roxoEscuro)",
                borderRadius: "0.5em",
                fontSize: 18,
                width: 160,
                top: 30,
              }}
            >
              {loadModal ? "Carregando..." : editando ? "Salvar" : "Cadastrar"}
            </Button>
          </div>
        </Box>
      </Modal>
    </div>
  );
}

export default CadastrarAluno;
